module.exports = __webpack_public_path__ + "img/stamp2.25205de1.png";